module.exports = __webpack_public_path__ + "static/media/banner.9e9a94e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/page_websitesec/banner.png
// module id = 793
// module chunks = 0